import React, { FC } from "react";

import AdGroupCreationForm from "../components/AdGroupCreationForm";
import TabPanel from "../../../../components/elements/TabPanel";
import { AdGroupToCreateType } from "../../../../types/campaignTypes";
import { PageStepComponentProps } from "../../../../components/modules/BaseStepper/BaseStepper";

type CreateNewAdGroupTabProps = {
  selectedTabPanelValue: number;
  updateAdGroup?: (values: AdGroupToCreateType) => void;
};

const CreateNewAdGroupTab: FC<PageStepComponentProps & CreateNewAdGroupTabProps> = ({
  isAttemptingToGoNext,
  setIsAttemptingToGoNext,
  handleNext,
  selectedTabPanelValue,
  updateAdGroup,
}) => {
  return (
    <TabPanel
      value={selectedTabPanelValue}
      index={1}
      id="adGroup-selection-tabpanel"
      ariaLabelledBy="adGroup-selection-tab"
    >
      <AdGroupCreationForm
        isAttemptingToGoNext={isAttemptingToGoNext}
        setIsAttemptingToGoNext={setIsAttemptingToGoNext}
        handleNext={handleNext}
        updateAdGroup={updateAdGroup}
      />
    </TabPanel>
  );
};

export default CreateNewAdGroupTab;
